module.exports = __webpack_public_path__ + "static/media/figure-10b.117526f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/faq/change-batteries/figure-10b.jpg
// module id = 1198
// module chunks = 0